import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceOldw {
    lookupService = new APIServiceLookUp();

    async getAllOldw(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}oldw/getAllOldw`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setOldw(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}oldw/setOldw`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delOldw(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}oldw/delOldw`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}